var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading && _vm.paymentLink)?_c('router-view'):_c('loading-page',{attrs:{"isFullPage":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }